// Keep the independently loaded poster until a decoded frame reaches the
// compositor. Calling play() alone can clear the browser's native poster.
export function revealVideoOnFirstFrame(video, reveal) {
  let stopped = false;
  let videoFrame = null;
  let animationFrame = null;
  const finish = () => {
    if (stopped) return;
    stopped = true;
    video.removeEventListener('playing', onPlaying);
    reveal();
  };
  const onPlaying = () => {
    if (stopped || videoFrame !== null || animationFrame !== null || video.readyState < 2) return;
    animationFrame = requestAnimationFrame(() => {
      animationFrame = requestAnimationFrame(() => {
        animationFrame = null;
        if (video.readyState >= 2) finish();
      });
    });
  };
  if (typeof video.requestVideoFrameCallback === 'function') {
    videoFrame = video.requestVideoFrameCallback(() => {
      videoFrame = null;
      finish();
    });
  } else {
    video.addEventListener('playing', onPlaying);
    if (!video.paused) onPlaying();
  }
  return () => {
    stopped = true;
    video.removeEventListener('playing', onPlaying);
    if (videoFrame !== null) video.cancelVideoFrameCallback(videoFrame);
    if (animationFrame !== null) cancelAnimationFrame(animationFrame);
  };
}
